import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { IBranchExchangeModel } from 'src/app/logic/branch/models/branch-exchange.model';
import { IBranchModel } from 'src/app/logic/branch/models/branch.model';
import { BranchExchangeUsecase } from 'src/app/logic/branch/usecases/branch-exchange.usercase';
import { IExchangeModel } from 'src/app/logic/exchanges/model/exchange.model';
import { BranchesService } from 'src/app/services/branches.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { ExchangeService } from 'src/app/services/exchange.service';
import {
  HeroSectionService,
  IHeroSection,
} from 'src/app/services/hero-section.service';
import { LanguageService } from 'src/app/services/language.service';
import { HeroSliderController } from 'src/app/shared/utils/hero-slider.controller';

@Component({
  selector: 'app-tabla-precios-auth',
  templateUrl: './tabla-precios-auth.component.html',
  styleUrls: ['./tabla-precios-auth.component.scss'],
})
export class TablaPreciosAuthComponent implements OnInit, OnDestroy {
  public isList: boolean = false;

  public tablaPrecios: any = [];
  public sucursalId: number = 0;
  public sucursales: IBranchModel[] = [];
  public sucursal: IBranchModel | undefined;
  public mxnExchange: IExchangeModel | undefined;
  public allExchanges: IExchangeModel[] = [];
  public divisas: any = [];

  readonly heroSlider = new HeroSliderController();

  get heroSections(): IHeroSection[] {
    return this.heroSlider.heroSections;
  }

  get isFading(): boolean {
    return this.heroSlider.isFading;
  }

  get currentSection(): IHeroSection | null {
    return this.heroSlider.currentSection;
  }

  get prevSection(): IHeroSection | null {
    return this.heroSlider.prevSection;
  }

  private openReserveSub$: Subscription | undefined;
  private languageSub$: Subscription | undefined;

  constructor(
    private readonly _branchExchange: BranchExchangeUsecase,
    private readonly _branchService: BranchesService,
    private readonly exchangeService: ExchangeService,
    private readonly heroSectionService: HeroSectionService,
    private readonly languageService: LanguageService,
    public dialog: MatDialog,
  ) {
    this.cargarSucursales();
  }

  ngOnInit(): void {
    this.loadHeroSections();

    this.languageSub$ = this.languageService.currentLanguage$.subscribe(() => {
      this.loadHeroSections();
    });

    this.openReserveSub$ = this._branchService.openReserveDialog$.subscribe(
      () => this.openDialog(this.tablaPrecios[0]),
    );
  }

  ngOnDestroy(): void {
    this.heroSlider.destroy();
    if (this.openReserveSub$) {
      this.openReserveSub$.unsubscribe();
    }
    if (this.languageSub$) {
      this.languageSub$.unsubscribe();
    }
  }

  private loadHeroSections(): void {
    this.heroSectionService.getActiveHeroSections().subscribe((sections) => {
      this.heroSlider.setSections(sections);
    });
  }

  onHeroFadeEnd(event: AnimationEvent): void {
    this.heroSlider.onFadeAnimationEnd(event.animationName);
  }

  cargarSucursales() {
    this._branchService.getAll().subscribe((branches: any) => {
      this.sucursales = branches;

      this._branchService.getBranchSelected().subscribe((branch) => {
        if (branch) {
          this.sucursal = branch;
          this.sucursalId = branch.id;

          this.sucursalSeleccionada(true);
        }
      });

      this._branchService.sucursalId.subscribe((id) => {
        if (id && id !== 0 && this.sucursalId !== id) {
          this.sucursalId = id;
          this.sucursalSeleccionada(false);
        }
      });
    });
  }

  sucursalSeleccionada(emit: boolean = true) {
    this.sucursal = this.sucursales.find(
      (value: IBranchModel) => value.id == this.sucursalId,
    );

    if (this.sucursal && emit) {
      this._branchService.setBranchSelected(this.sucursal);
    }

    this.cargarMonedas();
  }

  cargarMonedas() {
    this.exchangeService
      .getBranchExchangeRates(this.sucursalId)
      .subscribe((monedas: any) => {
        const exchangeList = structuredClone(monedas.exchange).sort(
          (a: any, b: any) =>
            Number(a?.currency?.order ?? 0) - Number(b?.currency?.order ?? 0),
        );
        this.allExchanges = exchangeList;

        this.mxnExchange = exchangeList.find(
          (value: any) => value.currency?.code === 'MXN',
        );
        this.tablaPrecios = exchangeList.filter(
          (value: any) => value.currency?.code !== 'MXN',
        );

        this.divisas = this.tablaPrecios;
      });
  }

  openDialog($event: any): void {
    const isMobile = window.innerWidth < 768;
    const config: MatDialogConfig = {
      data: {
        sucursal: this.sucursal,
        precios: structuredClone(this.allExchanges),
        tienes: this.mxnExchange,
        quieres: $event,
      },
      closeOnNavigation: true,
      disableClose: true,
      panelClass: 'custom-modalbox',
      position: { bottom: '0', right: '0' },
      maxHeight: isMobile ? '85vh' : '70vh',
    };

    this.dialog
      .open(ModalComponent, config)
      .afterClosed()
      .subscribe((result) => {});
  }
}
